// +----------------------------------------------------------------------
// | Desc:导入登录库
// +----------------------------------------------------------------------
import Vue from "vue";

// +----------------------------------------------------------------------
// | Desc:更新登录信息
// +----------------------------------------------------------------------
Vue.prototype.$getNowUserGobal = function () {
  //验证登录缓存
  if (!this.$isLogin()) {
    return;
  }
  //向缓存获取登录信息
  let that = this;
  var nowUserGobal = that.$getLocalStorage("nowUserGobal");
  var nowUserGobalTime = that.$getLocalStorage("nowUserGobalTime");
  var thisTime = that.$getNowUnix();
  if (nowUserGobalTime + 300 > thisTime && !that.$isblank(nowUserGobal)) {
    //更新登录缓存
    that.$loginAction(nowUserGobal);
    return;
  }

  //向数据库获取登录信息
  that.$api.getNowUserGobal({}).then((res) => {
    if (res.code == 0) {
      //更新登录缓存
      that.$setLocalStorage("nowUserGobal", res.data);
      that.$setLocalStorage("nowUserGobalTime", that.$getNowUnix());

      //更新VUEX登录缓存
      that.$loginAction(nowUserGobal);
    } else {
      //执行登录丢失事件
      this.$loginOutAction();
    }
  });
};

// +----------------------------------------------------------------------
// | Desc:退出登录
// +----------------------------------------------------------------------
Vue.prototype.$loginOut = function () {
  this.$Modal.confirm({
    title: "退出登录提示",
    content: "<p>您确认要退出登录吗 ？</p>",
    onOk: () => {
      //执行登录丢失事件
      this.$loginOutAction();
    },
  });
};

// +----------------------------------------------------------------------
// | Desc:登录信息丢失后的事件
// +----------------------------------------------------------------------
Vue.prototype.$loginOutAction = function () {
  let that = this;

  //清理登录缓存
  that.$clearStorage();

  //清理VUEX登录缓存
  that.$store.commit("UPDATE_USER", {});
  that.$store.commit("UPDATE_TOAST_CAR", {});

  //刷新当前页面
  const currentRoute = this.$route;
  const requiresAuth = currentRoute.meta.requireAuth || false;
};

// +----------------------------------------------------------------------
// | Desc:登录信息有效的事件
// +----------------------------------------------------------------------
Vue.prototype.$loginAction = function (user) {
  let that = this;

  //清理VUEX登录缓存
  var user = this.$strToJson(user);
  that.$store.commit("UPDATE_USER", user || {});
  Vue.prototype.$U = user;
  Vue.prototype.$A = user.auth;

  //刷新当前页面
  const currentRoute = this.$route;
  const currentPath = currentRoute.path;
};

// +----------------------------------------------------------------------
// | Desc:验证登录
// +----------------------------------------------------------------------
Vue.prototype.$isLogin = function () {
  var isEmpty1 = this.$isblank(localStorage.getItem("token"));
  var isEmpty2 = this.$isblank(sessionStorage.getItem("token"));
  var isEmpty3 = this.$isblank(this.$getLocalStorage("nowUserGobal"));
  if (isEmpty1 && isEmpty2) {
    this.$loginOutAction();
    return false;
  }
  if (isEmpty3) {
    this.$loginOutAction();
    return false;
  }
  return true;
};
